<template>
    <v-container fluid class="container-full-bg-gray">
        <app-modal-prompt
            v-model="locationDialog"
            @confirm="confirmLocationDialog()"
            @cancel="cancelLocationDialog()"
        >
            <template #title>
                Seleccione Ubicación
            </template>
            <v-form ref="locationDialogForm">
                <v-col cols="12">
                    <v-select
                        v-model="location_path"
                        :items="locations"
                        label="Ubicación"
                        item-text="name"
                        item-value="path"
                        clearable
                    ></v-select>
                </v-col> 
            </v-form>
        </app-modal-prompt>
        
        <app-modal-prompt
            v-model="customCharge.showDialog"
            :loading="customCharge.loading" 
            width="800px"
            @confirm="confirmCustomChargeDialog()"
            @cancel="cancelCustomChargeDialog()">
            <template #title>
                Cargo Manual
            </template>
            <v-form ref="customChargeForm">
                <v-row v-for="(line, index) in customCharge.form.lines" :key="index" class="mb-2" >
                    <v-col cols="6">
                        <v-text-field
                        label="Concepto"
                        v-model="line.concept"
                        :rules="[customCharge.validationRules.required]"
                        />
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                        label="Cantidad"
                        v-model="line.quantity"
                        type="number"
                        :rules="[customCharge.validationRules.required, customCharge.validationRules.isTypeNumber, customCharge.validationRules.isInteger, customCharge.validationRules.greaterThanZero ]"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                        label="Precio (sin impuestos)"
                        :append-icon="'mdi-currency-eur'"
                        v-model="line.amount"
                        type="number"
                        :rules="[customCharge.validationRules.required, customCharge.validationRules.isTypeNumber, customCharge.validationRules.greaterThanZero, customCharge.validationRules.maxTwoDecimals ]"
                        />
                    </v-col>
                    <v-col cols="1">
                        <v-btn v-if="index === customCharge.form.lines.length - 1" icon class="rounded-lg v-btn primary white--text mt-3" primary @click="customChargeAddLine"> <v-icon>mdi-plus</v-icon></v-btn>
                        <v-btn v-else-if="customCharge.form.lines.length > 1" icon color="error" @click="customChargeRemoveLine(index)"><v-icon>mdi-delete</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </app-modal-prompt>

        <MessagePopup :message="message" :show_message="show_message" @close-message="show_message = false"></MessagePopup>
        <h1 class="title-color">Happy debugging :)</h1>
        <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
                <v-expansion-panel-header class="title title-color">
                    USER INFO
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                            <v-autocomplete 
                                label="Usuario"
                                v-model="user"
                                :items="users"
                                item-key="id"
                                item-text="username"
                                return-object
                                autocomplete="off"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2">
                            <v-btn min-width="100%" @click="loginas">Loginas</v-btn>
                        </v-col>
                        <v-col cols="2">
                            <v-btn min-width="100%" @click="go_admin('/admin/auth/user/?q=' + userData.username)">Go User Admin</v-btn>
                        </v-col>
                        <v-col cols="2">
                            <v-btn min-width="100%" @click="go_admin('/admin/crm/lead/?q=' + userData.username)">Go To Lead</v-btn> 
                            <!-- <v-btn min-width="100%" @click="go_lead()">Go To Lead</v-btn> -->
                        </v-col>
                        <v-col cols="2">
                            <v-btn min-width="100%" @click="get_me">Me</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="go_admin('/admin/adp/contract/?user__id__exact=' + userData.user)">Go contract Admin</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="go_contrato_vigente()">Go Contrato Vigente</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="go_last_contract()">Go último contrato</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="go_admin('/admin/adp/document/?username=' + userData.username)">Go User Documents</v-btn>
                        </v-col>
                    </v-row>

                    <v-row v-if="Object.keys(meInfo).length">
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="ID Usuario" v-model="meInfo.user" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="ID perfil" v-model="meInfo.id" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="Email" v-model="meInfo.email" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="Teléfono" v-model="meInfo.phone" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-autocomplete label="Emails Secundarios" v-model="meInfo.extra_emails" :items="meInfo.extra_emails" :readonly="true"></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="DNI" v-model="meInfo.dni" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="Nombre" v-model="meInfo.name" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="NIF / DNI" v-model="meInfo.bussnies_id" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="Razón social" v-model="meInfo.business_name" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field v-if="meInfo.companydb" label="Empresa" v-model="meInfo.companydb" :readonly="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="Dirección postal" v-model="meInfo.postal_address" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="CP" v-model="meInfo.post_code" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="Población" v-model="meInfo.province" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-checkbox label="Recibir novedades Inmatic" v-model="meInfo.recieve_newsletter" :readonly="true"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="program" v-model="meInfo.program" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="service_plan" v-model="meInfo.service_plan" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="selected_program" v-model="meInfo.selected_program" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="contract_type" v-model="meInfo.contract_type" :readonly="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-checkbox label="Términos y condiciones aceptados" v-model="meInfo.terms_accepted" :readonly="true"></v-checkbox>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field label="Fecha de aceptación de los terminos y condiciones" v-model="meInfo.terms_accepted_date" :readonly="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-checkbox label="Contrato de prestación de servicios aceptado" v-model="meInfo.contract_accepted" :readonly="true"></v-checkbox>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field label="Fecha de aceptación del Contrato de servicios" v-model="meInfo.contract_accepted_date" :readonly="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-checkbox label="Política de privacidad aceptada" v-model="meInfo.policy_accepted" :readonly="true"></v-checkbox>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field label="Fecha de aceptación de la Política de privacidad" v-model="meInfo.policy_accepted_date" :readonly="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-checkbox label="is_staff" v-model="meInfo.is_staff" :readonly="true"></v-checkbox>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-checkbox label="can_see_training_documents" v-model="meInfo.can_see_training_documents" :readonly="true"></v-checkbox>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-checkbox label="can_debug_documents" v-model="meInfo.can_debug_documents" :readonly="true"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="status" v-model="meInfo.status" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-0 pb-0">
                                    <v-text-field label="tutorial_step" v-model="meInfo.tutorial_step" :readonly="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3" class="pt-0 pb-0">
                                    <v-text-field label="version_worker_python" v-model="meInfo.version_worker_python" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pt-0 pb-0">
                                    <v-text-field label="service_version" v-model="meInfo.service_version" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pt-0 pb-0">
                                    <v-text-field label="service_upgrader_version" v-model="meInfo.service_upgrader_version" :readonly="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3" class="pt-0 pb-0">
                                    <v-text-field label="whoami_service" v-model="meInfo.whoami_service" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pt-0 pb-0">
                                    <v-text-field label="whoami_upgrader" v-model="meInfo.whoami_upgrader" :readonly="true"></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pt-0 pb-0">
                                    <v-checkbox label="worker_updateable" v-model="meInfo.worker_updateable" :readonly="true"></v-checkbox>
                                </v-col>
                                <v-col cols="3" class="pt-0 pb-0">
                                    <v-checkbox label="service_updateable" v-model="meInfo.service_updateable" :readonly="true"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="3" class="pt-0 pb-0">
                                <v-text-field label="worker_mode" v-model="this.worker_mode" :readonly="true"></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0">
                                    <v-textarea label="Notas técnicas" :value="meInfo.technical_notes" :readonly="true"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="pt-0 pb-0">
                                    <v-textarea label="available_features" :value="JSON.stringify(meInfo.available_features)" :readonly="true"/>
                                </v-col>
                                <v-col cols="6" class="pt-0 pb-0">
                                    <v-textarea label="default_settings" :value="JSON.stringify(meInfo.default_settings)" :readonly="true"/>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <JobProgress v-model="jobFormationDocuments.state" v-on:done="jobFormationDocumentsDone" :job_id="jobFormationDocuments.id">
                                <template v-slot:progress>
                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </template>
                                <template v-slot:quiet>
                                    <v-btn v-if="!jobFormationDocuments.downloading" @click="downloadFormationDocumentsZip()" min-width="100%">Formation Documents</v-btn>
                                </template>
                            </JobProgress>
                        </v-col>     

                        <v-col cols="2">
                            <v-btn @click="copyExeLink" min-width="100%">Copy Exe</v-btn>
                        </v-col><v-col cols="2">
                            <v-btn @click="copyToken" min-width="100%">Copy Token</v-btn>
                        </v-col>
                        <v-col cols="2">
                            <v-btn @click="showCreateCustomCharge" min-width="100%">Emitir cargo manual</v-btn>
                        </v-col>
                        <v-col cols="1">
                            <v-progress-circular 
                                v-if="loading_copy"
                                indeterminate
                                color="primary">
                            </v-progress-circular>
                        </v-col>
                        <v-col cols="2">
                            <v-btn @click="clearCache" min-width="100%">Clear User Caches</v-btn>
                        </v-col>
                        <v-col cols="2">
                            <v-btn @click="openVerifactuDialog" min-width="100%">Clientes Verifactu</v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="title title-color">
                    <v-tabs
                        v-model="currentZone"
                    >
                        <v-tab
                            key="diagnostico"
                            @click.native.stop
                        >
                            Diagnóstico
                        </v-tab>
                        <v-tab
                            key="workflow"
                            @click.native.stop
                        >
                            Workflow Usuarios/Leads
                        </v-tab>
                        <v-tab
                            key="opers"
                            @click.native.stop
                        >
                            Operaciones
                        </v-tab>
                        <v-tab
                            key="queries"
                            @click.native.stop
                        >
                            Queries
                        </v-tab>
                        <v-tab
                            key="files"
                            @click.native.stop
                        >
                            ficheros
                        </v-tab>
                        <v-tab
                            key="cdb_copy"
                            @click.native.stop
                        >
                            Copia CDBs
                        </v-tab>
                        <v-tab
                            key="user_engagement"
                            @click.native.stop
                        >
                            User Engagement
                        </v-tab>
                        <v-tab
                            key="companies_list"
                            @click.native.stop
                        >
                            Companies List
                        </v-tab>
                    </v-tabs>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-tabs-items v-model="currentZone" class="ma-3">
                        <v-tab-item
                            key="diagnostico"
                        >
                            <v-row>
                                <v-col cols="3">
                                    <v-btn v-if="userData.stop_accounting_manual" min-width="100%" @click="change_stop_accounting()">Volver a contabilizar</v-btn>
                                    <v-btn v-else min-width="100%" @click="change_stop_accounting()">Parar de contabilizar</v-btn>
                                </v-col>
                                <v-col cols="1"/>
                                <v-col cols="3">
                                    <v-btn v-if="remote_ops_settings['remote_ops_ws_active']=='False'" min-width="100%" @click="update_remote_ops_settings('remote_ops_ws_active','True')">Active Remote Ops WS</v-btn>
                                    <v-btn v-else min-width="100%" @click="update_remote_ops_settings('remote_ops_ws_active', 'False')">Disable Remote Ops WS</v-btn>
                                </v-col>
                                <v-col cols="2">
                                    
                                </v-col>
                            </v-row>

                            
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="getVersion" min-width="100%">Get Version</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['GetVersion']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="getServiceVersion" min-width="100%">Get Service Version REST</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['GetServiceVersion']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="getServiceVersionWS" min-width="100%">Get Service Version WS</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['GetServiceVersionWS']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="restartService" min-width="100%">Restart Service REST</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['RestartService']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3" v-if="!got_feature('feature_worker_mode_parallel')">
                                    <v-btn @click="restartServiceWS" min-width="100%">Restart Service WS</v-btn>
                                </v-col>
                                <v-col cols="3" v-else>
                                    
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['RestartServiceWS']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="updatePython" min-width="100%">Update Python</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['UpdatePython']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="updateServiceUpgrader" min-width="100%">Update Service Upgrader REST</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['UpdateServiceUpgrader']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="updateService" min-width="100%">Update Service WS</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['UpdateService']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="activateService" min-width="100%">Activate Service</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['ActivateService']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="whoami" min-width="100%">Who am i</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['Whoami']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="create_list_odbc_drivers" min-width="100%">List Odbc Drivers</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['ListOdbcDrivers']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="getNetworkDrives" min-width="100%">Get Network Drives</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['GetNetworkDrives']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="a3OpenCloseOp" min-width="100%" :loading="is_to_pending['A3OpenCloseOp']">
                                        A3 OPEN CLOSE OP
                                    </v-btn>
                                </v-col>
                                <v-col cols="1">
                                </v-col>
                                <v-col cols="3">
                                  <v-btn @click="createAutoflowOP('take_screenshot')" min-width="100%">
                                    Captura de Pantalla
                                  </v-btn>
                                </v-col>
                                <v-col cols="1">
                                </v-col>
                                <v-col cols="3">
                                  <v-btn @click="createAutoflowOP('take_video')" min-width="100%">
                                    Captura de Video
                                  </v-btn>
                                </v-col>
                                <v-col cols="1">
                                </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="3">
                                <v-btn @click="getServiceStats" min-width="100%">Get Service Stats</v-btn>
                              </v-col>
                              <v-col cols="1">
                                <v-progress-circular
                                    v-if="is_to_pending['GetServiceStats']"
                                    indeterminate
                                    color="primary">
                                </v-progress-circular>
                              </v-col>
                              <v-col cols="3">
                                <v-btn @click="getMutex" min-width="100%">Get Mutex</v-btn>
                              </v-col>
                              <v-col cols="1">
                                <v-progress-circular
                                    v-if="is_to_pending['GetMutex']"
                                    indeterminate
                                    color="primary">
                                </v-progress-circular>
                              </v-col>
                            </v-row>
                            <v-row v-if="isElectron">
                                <v-col cols="3">
                                    <v-btn @click="installService" min-width="100%">Install Service</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['InstallingService']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                        <v-tab-item key="workflow">
                            <user-lead-workflow></user-lead-workflow>
                        </v-tab-item>
                        <v-tab-item key="opers">
                            <v-row>
                                <v-col cols="4">
                                    <v-btn @click="migrateToConnectNetworkDrive" min-width="100%">Migrar a Connect Network Drive</v-btn>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="runCommand" min-width="100%">Run Command</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['RunCommand']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field 
                                        label="Ruta"
                                        v-model="run_command_params.path"
                                        type="text"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field 
                                        label="Unidad"
                                        v-model="run_command_params.unidad"
                                        type="text"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field 
                                        label="Usuario"
                                        v-model="run_command_params.user"
                                        type="text"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field 
                                        label="Contraseña"
                                        v-model="run_command_params.pass"
                                        type="text"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="getContanetDBList" min-width="100%">Get Contanet DB List</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['GetContanetDBList']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field 
                                        label="Ruta para operación GetContanetDBList"
                                        v-model="get_contanet_db_list_path"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="create_upgrade_sage_install" min-width="100%">Upgrade Sage Install</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['UpgradeSageInstall']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="create_upgrade_goldennet_install" min-width="100%">Upgrade Goldennet Install</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['UpgradeGoldennetInstall']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>

                                <v-col cols="3">
                                    <v-btn @click="create_upgrade_goldennet_install_sql" min-width="100%">Upgrade Goldennet Install SQL</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['UpgradeGoldennetInstallSQL']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="create_upgrade_glasof_install" min-width="100%">Upgrade Glasof Install</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['UpgradeGlasofInstall']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="create_monitor_maintenance" min-width="100%">Monitor Maintenance</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['MonitorMaintenance']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="launch_create_config_ini" min-width="100%">Launch CreateConfigIni</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['CreateConfigIni']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4">
                                    <v-btn 
                                        min-width="100%" 
                                        :loading="run_command_loading"
                                        @click="createRunCommand(false)">
                                        Run Command OS Architecture 
                                    </v-btn>
                                </v-col>
                                <v-col cols="4">
                                    <v-btn 
                                        :disabled="!args_run_command" 
                                        min-width="100%" 
                                        :loading="run_command_generic_loading"
                                        @click="createRunCommand(true)">
                                        Run Command Generic 
                                    </v-btn>
                                </v-col>
                                <v-col cols="4" class="pt-0 pb-0">
                                    <v-text-field 
                                        label='Run Command Args'
                                        placeholder='{"args": ["CMD.exe",...,"c:\\windows\\temp\\inmatic_log.log"]}'
                                        v-model="args_run_command"
                                        type="text"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4">
                                    <v-switch
                                        label="Versión de 64 bits activada"
                                        v-model="def_set_windows_64"
                                        :loading="loading_def_set_windows_64"
                                        block
                                        outlined
                                        hide-details
                                        class="pl-2"
                                        @click="updateValueWindows64()"
                                    >
                                    </v-switch>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                        <v-tab-item key="queries">
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="pre_create_query('AplifisaQuery')" min-width="100%">Aplifisa Query</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['AplifisaQuery']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="pre_create_query('AplifisaFiscalQuery')" min-width="100%">Aplifisa Fiscal Query</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['AplifisaFiscalQuery']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="create_query('GlasofQuery')" min-width="100%">Glasof Query</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['GlasofQuery']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="create_query('ContasolQuery')" min-width="100%">Contasol Query</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['ContasolQuery']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="create_query('EstimasolQuery')" min-width="100%">Estimasol Query</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['EstimasolQuery']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="create_query('ContasolCloudQuery')" min-width="100%">Contasol Cloud Query</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['ContasolCloudQuery']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="create_query('EstimasolCloudQuery')" min-width="100%">Estimasol Cloud Query</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['EstimasolCloudQuery']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="create_query('Sage200Query')" min-width="100%">Sage 200 Query</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['Sage200Query']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="create_query('Sage50Query')" min-width="100%">Sage 50 Query</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['Sage50Query']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="create_query('GoldenNetQuery')" min-width="100%">GoldenNet Query SQL</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['GoldenNetQuery']"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-circular>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea
                                        label="Query"
                                        v-model="query"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="2">
                                    <v-combobox
                                        label="DB Name"
                                        v-model="db_name"
                                        :items="['master', 'sage']"
                                        clearble
                                    ></v-combobox>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field
                                        label="DB User"
                                        v-model="db_user"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field
                                        label="Link Path"
                                        v-model="link_path"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                        <v-tab-item key="files">
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="getRegistryKey" min-width="100%">Find File Contanet</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['GetRegistryKey']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="findFiles('contanet', 'nst')" min-width="100%">Find Files Contanet</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['FindFiles']['contanet']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="findFile('aplifisa', 'CONTBD')" min-width="100%">Find File Aplifisa</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['FindFile']['aplifisa']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="findFile('a3', 'tecodir.dat')" min-width="100%">Find File A3</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['FindFile']['a3']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="findFile('contasol', 'general.accdb')" min-width="100%">Find File Contasol</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['FindFile']['contasol']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="findFiles('contasol', 'accdb')" min-width="100%">Find Files Contasol</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['FindFiles']['contasol']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-btn @click="findFile('monitor', 'empresas.dat')" min-width="100%">Find File Monitor</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                        v-if="is_to_pending['FindFile']['monitor']"
                                        indeterminate
                                        color="primary">
                                    </v-progress-circular>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field 
                                        label="depth"
                                        v-model="depth"
                                        type="number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-row>
                                        <v-col cols="5">
                                            <v-btn @click="uploadLogFile" min-width="100%">UploadLogFile REST</v-btn>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-progress-circular 
                                                v-if="is_to_pending['UploadLogFile']"
                                                indeterminate
                                                color="primary">
                                            </v-progress-circular>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-btn @click="uploadLogFileWS" min-width="100%">UploadLogFile WS</v-btn>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-progress-circular 
                                                v-if="is_to_pending['UploadLogFileWS']"
                                                indeterminate
                                                color="primary">
                                            </v-progress-circular>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <v-row>
                                        <v-col cols="2">
                                            <v-btn @click="uploadBackup" min-width="100%">UploadBackup</v-btn>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-btn @click="uploadBackupWS" min-width="100" :loading="is_to_pending['UploadBackupWS']">UploadBackup WS</v-btn>
                                        </v-col>
                                        <v-col cols="4" class="pt-0 pb-0">
                                            <v-combobox 
                                                autocomplete="off"
                                                label="Folder"
                                                v-model="uploadBackupFolder"
                                                :items="folders"
                                                item-key="value"
                                                item-text="value"
                                                :return-object="false"
                                                @input.native="e => {uploadBackupFolder = e.target.value}"
                                            >
                                                <template slot="item" slot-scope="data">
                                                    <template v-if="data.item.text">
                                                        {{ data.item.text }}
                                                    </template>
                                                    <template v-else>
                                                        {{ data.item.value }}
                                                    </template>
                                                </template>
                                            </v-combobox>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-progress-circular 
                                                v-if="is_to_pending['UploadBackup']"
                                                indeterminate
                                                color="primary">
                                            </v-progress-circular>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                        </v-tab-item>
                        <v-tab-item key="cdb_copy">
                            <v-row>
                                <v-col cols="5">
                                    <v-btn @click="create_cdb_copy" min-width="100%">Create CDB Copy</v-btn>
                                </v-col>
                                <v-col cols="1">
                                    <v-progress-circular 
                                    v-if="is_to_pending['CreateCDBCopy']"
                                    indeterminate
                                    color="primary">
                                </v-progress-circular>
                            </v-col>
                            <!-- <v-col cols="5">
                                <v-btn @click="create_cdb_copy_dirty" min-width="100%">Create CDB Copy Dirty</v-btn>
                            </v-col>
                            <v-col cols="1">
                                <v-progress-circular 
                                v-if="is_to_pending['CreateCDBCopyDirty']"
                                indeterminate
                                color="primary">
                            </v-progress-circular>
                        </v-col> -->
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-btn @click="create_template_cdb_copy" min-width="100%">Create CDB Template Copy</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field 
                            label="New Name"
                            v-model="form.templateCopy.name"
                            type="text"
                            ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field 
                                    label="CompanyDB ID"
                                    v-model="form.templateCopy.companydb"
                                    type="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-autocomplete 
                                    label="Usuario"
                                    v-model="form.templateCopy.user"
                                    :items="users"
                                    item-key="id"
                                    item-text="username"
                                    return-object
                                    autocomplete="off"
                                    >
                                </v-autocomplete>
                            </v-col>
                            
                        </v-row>
                    </v-tab-item>
                    <v-tab-item key="user_engagement">
                        <UserEngagement/>
                    </v-tab-item>
                    <v-tab-item key="companies_list">
                        <CompaniesList :user_data="userData"/>
                    </v-tab-item>
                    
                </v-tabs-items>
                
            </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="title title-color">
                    OPERATIONS
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="get_operations">Get Operations</v-btn>
                        </v-col>
                        <v-col cols="3" class="pt-0 pb-0">
                            <v-autocomplete 
                                label="Estado de la operación"
                                v-model="operation_state"
                                :items="operation_states"
                                item-key="value"
                                item-text="text"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0">
                            <v-text-field 
                                label="Nombre de la operación"
                                v-model="operation_name"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0">
                            <v-text-field 
                                label="Límite/Número de operaciones"
                                v-model="operation_limit"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-btn min-width="100%" :loading="is_to_pending['relaunchingCloudConnector']" @click="relaunch_cloud_connector">Relaunch cloud Conn.</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="pending_operations.length">
                        <v-col cols="12">                            
                            <v-row>
                                <v-col cols="12" class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="1" class="text-center buttom-border table-name primary--text">
                                            Id
                                        </v-col>
                                        <v-col cols="2" class="text-center buttom-border table-name primary--text">
                                            Name
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name primary--text">
                                            Channel
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name primary--text">
                                            CompanyID
                                        </v-col>
                                        <v-col cols="2" class="text-center buttom-border table-name primary--text">
                                            Written
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name primary--text">
                                            State
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name primary--text">
                                            Job Count
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name primary--text">
                                            To pending          
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name primary--text">   
                                            To Done         
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name final-row primary--text">
                                                    
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" v-for="oper, index in pending_operations" :key="index" class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="1" class="text-center buttom-border table-name">
                                            {{oper['id']}}
                                        </v-col>
                                        <v-col cols="2" class="text-center buttom-border table-name">
                                            {{oper['name']}}
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name">
                                            {{oper['channel']}}
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name">
                                            <span class="cdb__go-detail" @click="go_company_detail(oper['companydb'])">{{oper['companydb']}}</span>
                                        </v-col>
                                        <v-col cols="2" class="text-center buttom-border table-name">
                                            {{oper['written']}}
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name">
                                            {{oper['state']}}
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name">
                                            {{oper['async_job_count']}}
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name">
                                            <v-btn @click="putOperationToPendingById(oper['id'])">
                                                <v-icon v-once>
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name">
                                            <v-btn @click="putOperationToDoneById(oper['id'])">
                                                <v-icon v-once>
                                                    mdi-check
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="1" class="text-center buttom-border table-name final-row">
                                            <v-btn @click="show_oper(oper['id'])">
                                                <v-icon v-once>
                                                    mdi-eye
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>                    
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="2">
                            <v-btn min-width="100%" @click="go_admin('/admin/adp/operationelectron/?user__id__exact=' + userData.user)">Go Oper Admin</v-btn>
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0">
                            <v-text-field
                                label="Id Operación"
                                v-model="operId"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-btn min-width="100%" @click="get_operation_info">Get Oper Info</v-btn>
                        </v-col>
                        <v-col cols="2" class="pt-0 pb-0">
                            <v-text-field
                                label="Oper. State"
                                v-model="operInfo.state"
                                :readonly="true"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="operInfo.log">
                        <v-col cols="12" class="pa-0">
                            <v-row no-gutters>
                                <v-col cols="3" class="text-center buttom-border table-name primary--text">
                                    timestamp
                                </v-col>
                                <v-col cols="1" class="text-center buttom-border table-name primary--text">
                                    level
                                </v-col>
                                <v-col cols="8" class="text-center buttom-border table-name final-row primary--text">
                                    msg
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" v-for="log, index in operInfo.log" :key="index" class="pa-0">
                            <v-row no-gutters>
                                <v-col cols="3" class="text-center buttom-border table-name">
                                    {{log['timestamp']}}
                                </v-col>
                                <v-col cols="1" class="text-center buttom-border table-name">
                                    {{log['level']}}
                                </v-col>
                                <v-col :cols="hasThreadId(log['msg']) ? 4 : 8" class="text-center buttom-border table-name final-row">
                                    {{log['msg']}}
                                </v-col>
                                <v-col v-if="hasThreadId(log['msg'])" cols="2" class="text-center buttom-border table-name">
                                    <v-btn
                                        small
                                        color="error"
                                        :loading="killThreadScreenData[`kill_thread_${extractThreadId(log['msg'])}_loading`]"
                                        @click="create_kill_process_op(extractThreadId(log['msg']))">
                                        Kill Thread
                                    </v-btn>
                                </v-col>
                                <v-col v-if="hasThreadId(log['msg'])" cols="2" class="text-center buttom-border table-name">
                                    <v-btn
                                        small
                                        color="warning"
                                        :loading="killThreadScreenData[`kill_thread_${extractThreadId(log['msg'])}_loading`]"
                                        @click="create_test_kill_process_op(extractThreadId(log['msg']))">
                                        Test
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <br/><br/>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="title title-color">
                    ASYNC JOBS
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="3" class="pt-0 pb-0">
                            <v-text-field
                                label="Id Async Job"
                                v-model="ajId"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="get_aj_info">Get Async Job Info</v-btn>
                        </v-col>
                        <v-col cols="3" class="pt-0 pb-0">
                            <v-text-field
                                label="Async. Job State"
                                v-model="ajInfo.state"
                                :readonly="true"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="go_admin('/admin/jobs/asyncjob/' + ajId + '/change/')">Go AJ Admin Detail</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="pt-0 pb-0"> 
                            <v-text-field
                                label="Id Document"
                                v-model="docId"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="go_admin('/admin/jobs/asyncjob/?q=' + docId)">Go AsyncJob Admin</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%"
                                   @click="getAsignJobsIds">Get Async. Jobs Ids</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="jobsList.count">
                        <v-data-table
                            :headers="jobsList.header"
                            :items="jobsList.results"
                            :items-per-page="jobsList.limit"
                            :server-items-length="jobsList.count"
                            :loading="jobsList.loading"
                            @update:page="setPageAsignJobs"
                            @update:items-per-page="getItemPerPageAsignJobs"
                            @click:row="clickRowAsignJobs"
                            class="elevation-1"
                        ></v-data-table>
                    </v-row>
                    <v-row v-if="ajInfo">
                        <v-col cols="6" v-if="ajInfo.params && ajInfo.params.operations">
                            <p>Operaciones:</p>
                            <v-row>
                                <v-col cols="12" class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="6" class="text-center buttom-border table-name primary--text">
                                            code
                                        </v-col>
                                        <v-col cols="6" class="text-center buttom-border table-name final-row primary--text">
                                            state
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" v-for="oper, index in ajInfo.params.operations" :key="index" class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="6" class="text-center buttom-border table-name">
                                            {{oper['code']}}
                                        </v-col>
                                        <v-col cols="6" class="text-center buttom-border table-name final-row">
                                            {{oper['state']}}
                                        </v-col>
                                    </v-row>                    
                                </v-col>
                            </v-row>
                            <br/><br/>
                        </v-col>
                        <v-col cols="6" v-if="ajInfo.error">
                            <p>Error:</p>
                            <v-textarea v-model="ajInfo.error" :readonly="true"/>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="title title-color">
                    API REST
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="3">
                            <v-btn @click="dirty" min-width="100%">Get dirty</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="operation">Operation details</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="remoteOps">Remote ops</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="remoteOpsWS">Remote ops WS</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="account_moves_electron">Moves electron</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="account_moves_electron_by_tag">Moves electron by Tag</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="set_moves_tags">Set moves tags</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="invoices_electron">Invoices electron</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="invoices_pending_sync">Invoices pending sync</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="company_db_details">CompanyDB details</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-btn min-width="100%" @click="me">Me</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="pt-0 pb-0">
                            <v-text-field v-model="endpoint" label="Endpoint"/>
                        </v-col>
                        <v-col cols="1" class="pt-0 pb-0">
                            <v-select 
                                label="Method"
                                v-model="method"
                                :items="methods"
                                item-key="id"
                                item-text="name"
                                return-object
                            ></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-btn @click="go">go</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-textarea v-model="payload"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            Result: <br/>
                            {{result}}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="red--text">
                            {{status}}-
                            {{error}}
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-dialog v-model="verifactuDialog" max-width="900px">
            <v-card>
                <v-card-title class="headline">
                    Clientes pendientes de activación VERI*FACTU
                    <v-spacer></v-spacer>
                    <v-btn icon @click="verifactuDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="verifactuHeaders"
                        :items="verifactuCustomers"
                        :loading="verifactuLoading"
                        :items-per-page="10"
                        class="elevation-1"
                    >
                        <template v-slot:no-data>
                            <v-alert type="info" text>
                                No hay clientes pendientes de activación
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="verifactuDialog = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

		<v-snackbar v-model="snackbar.isVisible" :color="snackbar.color" :timeout="snackbar.timeout">
			{{ snackbar.text }}
		</v-snackbar>
    </v-container>
</template>

<script>
import JobProgress from '../components/JobProgress.vue';
import MessagePopup from '../components/MessagePopup.vue';
import UserLeadWorkflow from '../components/UserLeadWorkflow.vue'
import { jobs } from '../api/jobs.js';
import { client, client2 } from "@/api/client";
import { mapFields } from 'vuex-map-fields';
import { mapState, mapGetters, mapActions } from "vuex"
import { user as api_user } from "@/api/user";
import { createApiTokenRepository } from '@/modules/tokens/infrastructure/ApiTokenRepository';
import { getToken } from '@/modules/tokens/application/getToken';
import { copyToken } from '@/modules/tokens/application/copyToken';
import UserEngagement from '../components/UserEngagement.vue';
import CompaniesList from '../components/CompaniesList.vue';
import {RelaunchCloudConnector} from '@/modules/invoices/app/RelaunchCloudConnector' 
import { sync_command_dispatcher, async_command_dispatcher, query_dispatcher } from "@/api/client";
import {ClearUserCaches} from '@/modules/accounts/app/ClearUserCaches';
import { KillThreadProcess } from '@/modules/conector_ops/application/KillThreadProcess';
import { A3RunCommand } from '@/modules/conector_ops/application/A3RunCommand';
import { RunCommandCreationCommand } from  '@/modules/conector_ops/application/CreateRunnCommand'
import { ChangeWindowsArchitectureSettingsCommand } from "@/modules/accounts/app/ChangeWindowsArchitectureSettings"
import { GetOSArchitectureQuery } from "@/modules/accounts/app/GetOSArchitecture"
import AppModalPrompt from '../components/layout/AppModalPrompt.vue';
import { CreateCustomChargeCommand } from "@/modules/revenue/app/CreateCustomChargeCommand";

    export default {
        name:'Debug',
        components: {
            MessagePopup,
            UserLeadWorkflow,
            JobProgress,
            UserEngagement,
            CompaniesList,
            AppModalPrompt
        },
        props: {
            username: {
                type: String,
                required: false,
                default: function () {
                    return "";
                },
            },
        },
        created() {
            this.get_remote_ops_settings();
        },
        data(){
            return {
                panel: [0,1],

                endpoint:'',
                method:{'id':'get','name':'GET'},
                methods:[
                    {'id':'get','name':'GET'}, 
                    {'id':'post','name':'POST'},
                    {'id':'patch','name':'PATCH'}, 
                ],
                result:'--',
                status:'',
                error:'',
                payload:'',
                users: [],
                user: null,
                operId: '',
                operInfo: {},
                docId: '',
                ajId: '',
                ajInfo: {},
                remote_ops_settings: {'remote_ops_ws_active': 'False'},
                is_to_pending: {
                    'GetVersion': false, 
                    'GetServiceVersion': false, 
                    'GetServiceVersionWS': false, 
                    'RestartService': false,
                    'RestartServiceWS': false,
                    'UpdatePython': false,
                    'UploadLogFile': false,
                    'UploadLogFileWS': false,
                    'uploadBackupWS': false,
                    'UploadBackup': false,
                    'CreateCDBCopy': false,
                    'CreateCDBCopyDirty': false,
                    'UpdateServiceUpgrader': false,
                    'UpdateService': false,
                    'Whoami': false,
                    'GetRegistryKey': false,
                    'FindFile': {
                        'aplifisa': false,
                        'a3': false,
                        'contasol': false,
                        'monitor': false,
                    },
                    'FindFiles': {
                        'contanet': false,
                        'contasol': false,
                    },
                    'ActivateService': false,
                    'GetContanetDBList': false,
                    'GetNetworkDrives': false,
                    'RunCommand': false,
                    'UpgradeSageInstall': false,
                    'UpgradeGoldennetInstall': false,
                    'UpgradeGoldennetInstallSQL': false,
                    'UpgradeGlasofInstall': false,
                    'MonitorMaintenance': false,
                    'CreateConfigIni': false,
                    // 'GlasofQuery': false,
                    'ListOdbcDrivers': false,

                    'AplifisaFiscalQuery': false, 
                    'AplifisaQuery': false,  
                    'ContasolCloudQuery': false, 
                    'ContasolQuery': false, 
                    'EstimasolCloudQuery': false, 
                    'EstimasolQuery': false,
                    'GlasofQuery': false, 
                    'Sage200Query': false,
                    'Sage50Query': false,
                    'GoldenNetQuery': false,
                    'relaunchingCloudConnector': false,
                    'InstallingService': false,
                    'A3OpenCloseOp': false,
                    'GetServiceStats': false,
                    'GetMutex': false,
                },
                pending_operations: [],
                operation_states: [
                    {
                        'text': 'All',
                        'value': 'all',
                    },
                    {
                        'text': 'Pending',
                        'value': 'pending',
                    },
                    {
                        'text': 'Done',
                        'value': 'done',
                    },
                    {
                        'text': 'Error',
                        'value': 'error',
                    },
                    {
                        'text': 'Running',
                        'value': 'running',
                    },
                    {
                        'text': 'Scheduled',
                        'value': 'scheduled',
                    },
                ],
                operation_state: 'all',
                operation_name: '',
                operation_limit: '',
                meInfo: {},
                uploadBackupFolder: '',
                folders: [
                    {'value': 'c:\\aplifisa\\contcs\\contbd'},
                    {'value': 'c:\\aplifisa\\gfiscal\\gfisbd'},
                    {'value': 'c:\\a3\\a3asesor\\e', 'text': 'c:\\a3\\a3asesor\\exxxxx'},
                    {'value': 'C:\\Windows\\Temp\\last_inmatic_stack.txt'},
                ],
                get_contanet_db_list_path: '',
                depth: 4,
                jobFormationDocuments: {
                    "id": 0,
                    "name": "documentos",
                    "format": "zip",
                    "state": "done",
                    "downloading": false
                },
                show_message: false,
                message: '',
                clickedZone: undefined,
                run_command_params: {
                    'unidad': '',
                    'path': '',
                    'user': '',
                    'pass': '',
                },
                form: {
                    templateCopy: {
                        name: 'Empresa de Prueba',
                        companydb: undefined,
                        user: undefined
                    },
                    select: {
                        companyiesdb: []
                    }
                },
                query: '',
                db_name: '',
                db_user: '',
                link_path: '',
                location_path: '',
                query_operation: '',
                locationDialog: false,
                jobsList: {
                    results: [],
                    count: 0,
                    header: [
                        {text: 'Id', value: 'id'},
                        {text: 'State', value: 'state'}
                    ],
                    limit: 10,
                    offset: 0,
                    loading: false
                },
                loading_copy: false,
                userEngagement: {
                    id: "",
                    contract: "",
                    connector: "",
                    email: "",
                    phoneNumber: "",
                },
                last_relaunch_date:'',
                args_run_command:'',
                run_command_loading: false,
                run_command_generic_loading:false,
                def_set_windows_64: false,
                loading_def_set_windows_64: false,
                isElectron: false,
                customCharge:{
                    showDialog: false,
                    loading: false,
                    form: {
                        lines: [
                            { concept: '', quantity: 1, amount: null }
                        ]
                    },
                    validationRules: {
                        required: v => !!v || 'Campo obligatorio',
                        isTypeNumber: v => !isNaN( Number(v) ) || 'El abono debe ser un número',
                        isInteger: v => Number.isInteger(Number(v)) || 'Debe ser un número entero',
				        greaterThanZero: v => v > 0 || 'El número debe ser mayor que 0.',
                        maxTwoDecimals: v => {
                            const regex = /^-?\d+(\.\d{1,2})?$/;
                            return regex.test(v) || 'Sólo se permiten hasta dos decimales';
                        },
                    },
                },
                snackbar: {
                    isVisible: false,
                    text: '',
                    color: '',
                    timeout: 2000,
                },
                autoflow_video_duration: 50,
                worker_mode: null,
                killThreadScreenData: {},
                verifactuDialog: false,
                verifactuCustomers: [],
                verifactuLoading: false,
                verifactuHeaders: [
                    { text: 'ID', value: 'id', sortable: true },
                    { text: 'CIF', value: 'cif', sortable: true },
                    { text: 'Nombre', value: 'name', sortable: true }
                ],
            }
        },
        computed:{
            ...mapGetters({
                userData: "me/userData",
                exe_link: "tutorial/exe_link",
                got_feature: 'got_feature',
            }),
            ...mapState(['currentCompany', 'session_information']),
            ...mapFields('connector', {
                locations: 'locations',
            }),
            currentZone: {
                get() {
                    if (this.clickedZone!=undefined) {
                        return this.clickedZone;
                    } else {
                        return 0;
                    }
                },
                set(newValue) {
                    if (newValue != this.currentZone) {
                        this.clickedZone = newValue;
                    }
                },
            },
        },
        methods:{
            ...mapActions([
                'setLoginas',
            ]),
            ...mapActions({
                downloadFormationDocuments:"documents/downloadFormationDocuments",
                setUserData: "me/setUserData",
                setExeLink: "tutorial/setExeLink",
                getLocations: 'connector/getLocations',
            }),
            async openVerifactuDialog() {
                this.verifactuDialog = true;
                this.verifactuLoading = true;
                try {
                    const response = await query_dispatcher.dispatch('get.customers.to.activate.verifactu', {});
                    this.verifactuCustomers = Array.isArray(response) ? response : [];
                } catch (error) {
                    console.error('Error cargando clientes para Verifactu:', error);
                    this.snackbar.text = 'Error al cargar clientes pendientes de Verifactu';
                    this.snackbar.color = 'error';
                    this.snackbar.isVisible = true;
                } finally {
                    this.verifactuLoading = false;
                }
            },
            go(){
                this.result="calling..."
                this.status=''
                this.error=''
                if(this.method.id=='get'){
                    client.get(this.endpoint).then(response=>{
                        this.result=response.data
                        this.status=response.status
                        console.debug(response)
                    },
                    error=>{
                        this.error=error
                        this.result=''
                        this.status=''
                        console.debug(error)
                        console.debug(error.status)
                    })
                }else{
                    client[this.method.id](this.endpoint,JSON.parse(this.payload)).then(response=>{
                        this.result=response.data
                        this.status=response.status
                        console.debug(response)
                    },
                    error=>{
                        this.result=''
                        this.status=''
                        console.debug(error)
                        console.debug(error.status)
                    })
                }
            },
            dirty(){
                this.endpoint='get_companies_info/'+this.currentCompany.id+'/'
                this.method=this.methods[0]
            },
            operation(){
                this.endpoint='operations/<id>/'
                this.method=this.methods[0]
            },
            remoteOps(){
                this.endpoint='remote_ops/'
                this.method=this.methods[0]
            },
            remoteOpsWS(){
                this.endpoint='remote_ops_ws/'
                this.method=this.methods[0]
            },
            account_moves_electron(){
                this.endpoint='account_moves_electron/'
                this.method=this.methods[0]
            },
            account_moves_electron_by_tag(){
                this.endpoint='account_moves_electron_by_tag/?tags=test_tag1,test_tag2'
                this.method=this.methods[0]
            },
            set_moves_tags(){
                this.endpoint='set_account_moves_tags/'
                this.payload=JSON.stringify({
                    "moves":[],
                    "tags_add":[],
                    "tags_remove":[],
                })
                this.method=this.methods[1]
            },
            invoices_electron(){
                this.endpoint='invoices_electron/'
                this.method=this.methods[0]
            },
            invoices_pending_sync(){
                this.endpoint='invoices_pending_sync/'
                this.method=this.methods[0]
            },
            company_db_details(){
                this.endpoint='companydbs_detail/<id>'
                this.method=this.methods[0]
            },
            me() {
                this.endpoint='me/'
                this.method=this.methods[0]
            },
            get_users() {
                let session_username = this.session_information.username;
                client.get('get_users_to_loginas/', { params:{ 'session_username': session_username}}).then(response => {
                    this.users = response.data;
                }).catch(err => {
                    console.debug(err);
                });
            },
            loginas() {
                this.setLoginas(this.user['username']).then(()=>{
                    this.$router.go();
                });
            },
            go_admin(url) {
                let href = window.location.origin.replace('app', 'api') + url;
                window.open(href, '_blank');
            },
            go_lead() {
                client.get('get_lead_id/').then(resp => {
                    let leadId = resp.data['id']
                    if (leadId) {
                        this.go_admin('/admin/crm/lead/' + leadId + '/change/');
                    } else {
                        this.message='Este usuario no tiene lead';
                        this.show_message=true;
                    }
                }); 
            },
            go_company_detail(id_company) {
                if (id_company) {
                    let href = "/connector/" + id_company;
                    window.open(href, '_blank');
                }
            },
            go_contrato_vigente() {
                let id = 0;
                for (let i in this.userData.contracts) {
                    if (this.userData.contracts[i]['is_vigente']) {
                        id = this.userData.contracts[i]['id']
                    }
                }
                this.go_admin('/admin/adp/contract/' + id + '/change/');
            },
            go_last_contract() {
                let id = 0;
                for (let i in this.userData.contracts) {
                    if (this.userData.contracts[i]['is_actualizable']) {
                        id = this.userData.contracts[i]['id']
                    }
                }
                this.go_admin('/admin/adp/contract/' + id + '/change/');
            },

            get_operation_info() {
                client.get('operations_debug/' + this.operId).then(response => {
                    this.operInfo = response.data;
                }).catch(err => {
                    console.debug(err);
                });
            },
            get_aj_info() {
                client.get('jobs/jobs/' + this.ajId).then(response => {
                    this.ajInfo = response.data;
                }).catch(err => {
                    console.debug(err);
                });
            },
            putOperationToPending(name, channel, key) {
                return new Promise((resolve, reject)=> {
                    this.is_to_pending[key] = true;
                    client.put('operation_to_pending/', { 'name': name, 'channel': channel }).then(() => {
                        this.is_to_pending[key] = false;
                        this.operation_limit = '';
                        this.operation_name = '';
                        this.operation_state = 'all';
                        this.get_operations();
                        resolve();
                    }).catch(err => reject(err));
                });
            },
            async getVersion() {
                this.putOperationToPending('GetVersion', 'rest', 'GetVersion');
            },
            async getServiceVersion() {
                this.putOperationToPending('GetServiceVersion', 'rest', 'GetServiceVersion');
            },
            async getServiceVersionWS() {
                this.putOperationToPending('GetServiceVersion', 'websocket', 'GetServiceVersionWS');
            },
            async getServiceStats() {
              this.putOperationToPending('GetServiceStats', 'rest', 'GetServiceStats');
            },
            async getMutex() {
              this.putOperationToPending('GetMutex', 'rest', 'GetMutex');
            },
            async restartService() {
                this.putOperationToPending('RestartService', 'rest', 'RestartService');
            },
            async restartServiceWS() {
                this.putOperationToPending('RestartService', 'websocket', 'RestartServiceWS');
            },
            updatePython() {
                this.is_to_pending['UpdatePython'] = true;
                client.put('create_update_python_operation/').then(() => {
                    this.is_to_pending['UpdatePython'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
                
            },
            updateServiceUpgrader() {
                this.is_to_pending['UpdateServiceUpgrader'] = true;
                client.put('create_update_service_upgrader_operation/').then(() => {
                    this.is_to_pending['UpdateServiceUpgrader'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            async relaunch_cloud_connector() {
                this.is_to_pending['relaunchingCloudConnector'] = true;
                this.last_relaunch_date = (await new RelaunchCloudConnector(sync_command_dispatcher).run())['output']
                this.is_to_pending['relaunchingCloudConnector'] = false;
                this.operation_limit = '';
                this.operation_name = '';
                this.operation_state = 'all';
                this.get_operations();
            },
            updateService() {
                this.is_to_pending['UpdateService'] = true;
                client.put('create_update_service_operation/').then(() => {
                    this.is_to_pending['UpdateService'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            whoami() {
                this.is_to_pending['Whoami'] = true;
                client.put('create_whoami_operations/').then(() => {
                    this.is_to_pending['Whoami'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            getRegistryKey() {
                this.is_to_pending['GetRegistryKey'] = true;
                client.put('create_get_registry_key_operation/').then(() => {
                    this.is_to_pending['GetRegistryKey'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            findFile(cdb_type, file_name) {
                this.is_to_pending['FindFile'][cdb_type] = true;
                client.put('create_find_file_operation/', { 'file_name': file_name, 'depth': parseInt(this.depth) }).then(() => {
                    this.is_to_pending['FindFile'][cdb_type] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            findFiles(cdb_type, file_name) {
                this.is_to_pending['FindFiles'][cdb_type] = true;
                client.put('create_find_files_operation/', { 'file_name': file_name, 'depth': parseInt(this.depth) }).then(() => {
                    this.is_to_pending['FindFiles'][cdb_type] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            showMessage(m){
                this.message=m;
                this.show_message=true;
            },

            async jobFormationDocumentsDone() {
                this.jobFormationDocuments.downloading = false;
                try {
                    const resp = await jobs.getJobFile({ id: this.jobFormationDocuments.id });
                    let fileURL = resp.data.url;
                    if (fileURL) {
                        const response = await fetch(fileURL)
                        const blob = await response.blob();
                        const url = await URL.createObjectURL(blob)
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = this.jobFormationDocuments.name + "." + this.jobFormationDocuments.format;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    } else {
                        let message = "No hay documentos de formación." 
                        this.showMessage(message)   
                    }
                } catch(err) {
                    console.debug(err)
                }
            },

            downloadFormationDocumentsZip() {
                this.jobFormationDocuments.downloading = true;
                this.downloadFormationDocuments().then(response => {
                    this.jobFormationDocuments.id = response.data['AsyncJob'];
                    this.jobFormationDocuments.state = "running";
                }, error => {
                    this.showMessage('Algo ha ido mal')
                    console.error(err)
                });
            },
            activateService() {
                this.is_to_pending['ActivateService'] = true;
                client.put('create_activate_service_operation/').then(() => {
                    this.is_to_pending['ActivateService'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            getContanetDBList() {
                this.is_to_pending['GetContanetDBList'] = true;
                client.put('create_get_contanet_db_list_operation/', {'search_path': this.get_contanet_db_list_path}).then(() => {
                    this.is_to_pending['GetContanetDBList'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            getNetworkDrives() {
                this.is_to_pending['GetNetworkDrives'] = true;
                client.put('create_get_network_drives_operation/').then(() => {
                    this.is_to_pending['GetNetworkDrives'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            runCommand() {
                if (this.run_command_params.path && this.run_command_params.unidad) { 
                    this.is_to_pending['RunCommand'] = true;
                    client.put('create_run_command_operation/', this.run_command_params).then(() => {
                        this.is_to_pending['RunCommand'] = false;
                        this.operation_limit = '';
                        this.operation_name = '';
                        this.operation_state = 'all';
                        this.get_operations();
                    });
                }
            },
            migrateToConnectNetworkDrive() {
                client.put('migrate_run_command_to_get_network_drive/', {}).then(() => {
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            get_operations() {
                let filter = '?order_by=-written';
                if (this.operation_state != 'all') {
                    filter = filter + '&state=' + this.operation_state;
                }
                if (this.operation_name) {
                    filter = filter + '&name=' + this.operation_name;
                }
                if (this.operation_limit) {
                    filter = filter + '&limit=' + this.operation_limit;
                }
                client.get('operations_debug/' + filter).then(resp => {
                    this.pending_operations = resp.data.results;
                });
            },
            get_me() {
                client2.get('me/').then(response => {
                    this.meInfo = response.data.results;
                    this.get_worker_mode();
                }).catch(err => {
                    console.debug(err);
                });
            },
            get_worker_mode(){
              if (this.got_feature('feature_interactive_mode_connector')) {
                this.worker_mode = 'interactive';
                return;
              } else if (this.got_feature('feature_run_as_task_mode_connector')) {
                this.worker_mode = 'run_as_task';
                return;
              } else if (this.got_feature('feature_worker_mode_parallel')) {
                this.worker_mode = 'parallel';
                return;
              }
              this.worker_mode = 'serial'
            },
            show_oper(id) {
                this.operId = id;
                this.get_operation_info();
            },
            putOperationToPendingById(id) {
                client.patch('operations_debug/' + id + '/', { 'state': 'pending' }).then(() => {
                    // this.operation_limit = '';
                    // this.operation_name = '';
                    // this.operation_state = 'all';
                    this.get_operations();
                }).catch(err => {
                    console.debug(err);
                });
            },
            putOperationToDoneById(id) {
                client.patch('operations_debug/' + id + '/', { 'state': 'done' }).then(() => {
                    this.get_operations();
                }).catch(err => {
                    console.debug(err);
                });
            },
            uploadLogFile() {
                let session_username = this.session_information.username;
                this.is_to_pending['UploadLogFile'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'UploadLogFile', 'channel': 'rest' }}).then(() => {
                    this.is_to_pending['UploadLogFile'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            uploadLogFileWS() {
                let session_username = this.session_information.username;
                this.is_to_pending['UploadLogFileWS'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'UploadLogFile', 'channel': 'websocket' }}).then(() => {
                    this.is_to_pending['UploadLogFileWS'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            uploadBackupWS() {
                let session_username = this.session_information.username;
                this.is_to_pending['UploadBackupWS'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'UploadBackup', 'channel': 'websocket', 'args': { 'folder': this.uploadBackupFolder } }}).then(() => {
                    this.is_to_pending['UploadBackupWS'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            uploadBackup() {
                let session_username = this.session_information.username;
                this.is_to_pending['UploadBackup'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'UploadBackup', 'channel': 'rest', 'args': { 'folder': this.uploadBackupFolder } }}).then(() => {
                    this.is_to_pending['UploadBackup'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            create_cdb_copy() {
                let session_username = this.session_information.username;
                this.is_to_pending['CreateCDBCopy'] = true;
                client.post('create_cdb_copy/', { 'session_username': session_username, 'cdb_id': this.currentCompany.id, 'writting': true}).then(() => {
                    this.is_to_pending['CreateCDBCopy'] = false;
                });

            },
            create_template_cdb_copy() {
                const data = {
                    username: this.form.templateCopy.user.username,
                    cdb_id: this.form.templateCopy.companydb,
                    new_name: this.form.templateCopy.name
                };
                client.post('create_template_cdb_copy/', data).then((response) => {
                    this.form.templateCopy.companydb = undefined;
                    this.form.templateCopy.name = 'Empresa de Prueba';
                    this.form.templateCopy.user = undefined;
                });
            },
            create_cdb_copy_dirty() {
                let session_username = this.session_information.username;
                this.is_to_pending['CreateCDBCopyDirty'] = true;
                client.post('create_cdb_copy/', { 'session_username': session_username, 'cdb_id': this.currentCompany.id, 'writting': false}).then(() => {
                    this.is_to_pending['CreateCDBCopyDirty'] = false;
                });
            },
            async change_stop_accounting() {
                let params = {
                    'stop_accounting_manual': !this.userData.stop_accounting_manual,
                }
                const response = await api_user.setUserInfo(params);
                this.setUserData(response.data.results);
            },
            create_upgrade_sage_install() {
                let session_username = this.session_information.username;
                this.is_to_pending['UpgradeSageInstall'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'UpgradeSageInstall', 'channel': 'rest' }}).then(() => {
                    this.is_to_pending['UpgradeSageInstall'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            create_upgrade_goldennet_install() {
                let session_username = this.session_information.username;
                this.is_to_pending['UpgradeGoldennetInstall'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'UpgradeGoldennetInstall', 'channel': 'rest' }}).then(() => {
                    this.is_to_pending['UpgradeGoldennetInstall'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            create_upgrade_goldennet_install_sql() {
                let session_username = this.session_information.username;
                this.is_to_pending['UpgradeGoldennetInstallSQL'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'UpgradeGoldennetInstall', 'channel': 'rest', 'args': { 'is_sql': true } }}).then(() => {
                    this.is_to_pending['UpgradeGoldennetInstallSQL'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            create_upgrade_glasof_install() {
                let session_username = this.session_information.username;
                this.is_to_pending['UpgradeGlasofInstall'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'UpgradeGlasofInstall', 'channel': 'rest' }}).then(() => {
                    this.is_to_pending['UpgradeGlasofInstall'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            create_monitor_maintenance() {
                let session_username = this.session_information.username;
                this.is_to_pending['MonitorMaintenance'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'MonitorMaintenance', 'channel': 'rest', 'duration': 10 }}).then(() => {
                    this.is_to_pending['MonitorMaintenance'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            launch_create_config_ini() {
                let session_username = this.session_information.username;
                this.is_to_pending['CreateConfigIni'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'CreateConfigIni', 'channel': 'rest', 'args': {'ll': 20}}}).then(() => {
                    this.is_to_pending['CreateConfigIni'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            resetLocationDialog() {
                this.location_path = '';
                this.query_operation = '';
            },
            confirmLocationDialog() {
                this.create_query(this.query_operation);
                this.locationDialog = false;
                this.resetLocationDialog();
            },
            cancelLocationDialog() {
                this.locationDialog = false;
                this.resetLocationDialog();
            },
            async is_job_done(job_id){
                if (job_id){
                    let response = await client.get('jobs/jobs/'+job_id.toString());
                    if (response.data.state == 'running'){
                        setTimeout(()=>this.is_job_done(job_id),1000);
                    } else {
                        let errorMsg = "";
                        let successMsg = "";
                        switch (this.actionModal) {
                            case "createCustomCharge":
                                this.customCharge.loading = false;
                                this.customCharge.showDialog = false;
                                errorMsg = response.data.output_info.message;
                                successMsg = response.data.output_info.message
                                break;
                            default:
                                break;
                        }
                        if(response.data.state == 'error' || (response.data.output_info && !response.data.output_info.success) ){
                            this.setSnackbar('error', errorMsg);
                        } else {
                            this.setSnackbar('success', successMsg);
                        }
                        // this.refreshContractsList();
                    }
                }
            },
            async APIcreateCustomCharge(user_id, lines) {
                try {
                    let response = await new CreateCustomChargeCommand(async_command_dispatcher).run(user_id, lines)
                    setTimeout(()=>this.is_job_done(response.job_id), 1000)
                }
                catch(error) {
                    console.log(error)
                    this.setSnackbar('error', error);
                }
            },
            customChargeAddLine() {
                this.customCharge.form.lines.push({ concept: '', quantity: 1, amount: '' })
            },
            customChargeRemoveLine(index) {
                this.customCharge.form.lines.splice(index, 1);
            },
            confirmCustomChargeDialog() {
                this.customCharge.form.error = false
                const isValid = this.$refs.customChargeForm.validate()
                if (isValid) {
                    this.customCharge.loading = true;
                    this.APIcreateCustomCharge(this.userData.id, this.customCharge.form.lines);
                } else {
                    this.setSnackbar('error', 'Revise los errores del formulario.')
                }
            },
            cancelCustomChargeDialog() {
                this.customCharge.showDialog = false;
                this.customCharge.form = {
                    lines: [],
                    error: false,
                    loading: false
                };
			    this.$refs.customChargeForm.resetValidation();
            },
            async pre_create_query(operation) {
                var has_locations = false;
                if (this.got_feature('feature_config_locations')) {
                    this.query_operation = operation;
                    if (operation == 'AplifisaQuery') {
                        await this.getLocations('aplifisa');
                    }
                    else if (operation == 'AplifisaFiscalQuery') {
                        await this.getLocations('aplifisa_fiscal');
                    }
                    if (this.locations.length) {
                        has_locations = true;
                        this.locationDialog = true;
                    }
                }
                if (!has_locations) {
                    this.create_query(operation);
                }
            },
            create_query(operation) {
                let session_username = this.session_information.username;
                this.is_to_pending[operation] = true;
                let args = {
                    "query": this.query, 
                    // "db_name": this.db_name
                };
                if (this.db_name) {
                    args['db_name'] = this.db_name;
                }
                if (this.db_user) {
                    args['db_user'] = this.db_user;
                }
                if (this.link_path) {
                    args['link_path'] = this.link_path;
                }
                if (this.location_path) {
                    args['location_path'] = this.location_path;
                }

                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': operation, 'channel': 'rest', 'args': args }}).then(() => {
                    this.is_to_pending[operation] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            // create_glasof_query() {
            //     let session_username = this.session_information.username;
            //     this.is_to_pending['GlasofQuery'] = true;
            //     let args = {
            //         "query": this.query, 
            //         "db_name": this.db_name
            //     };
            //     client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'GlasofQuery', 'channel': 'rest', 'args': args }}).then(() => {
            //         this.is_to_pending['GlasofQuery'] = false;
            //         this.operation_limit = '';
            //         this.operation_name = '';
            //         this.operation_state = 'all';
            //         this.get_operations();
            //     });
            // },
            create_list_odbc_drivers() {
                let session_username = this.session_information.username;
                this.is_to_pending['ListOdbcDrivers'] = true;
                client.put('create_operation/', { 'session_username': session_username, 'params': { 'name': 'ListOdbcDrivers', 'channel': 'rest' }}).then(() => {
                    this.is_to_pending['ListOdbcDrivers'] = false;
                    this.operation_limit = '';
                    this.operation_name = '';
                    this.operation_state = 'all';
                    this.get_operations();
                });
            },
            a3OpenCloseOp() {
                this.is_to_pending['A3OpenCloseOp'] = true;
                new A3RunCommand(sync_command_dispatcher).run(this.currentCompany.id).then((response) => {
                    this.is_to_pending['A3OpenCloseOp'] = false;
                    this.get_operations();
                })
                .catch(error => {
                    this.is_to_pending['A3OpenCloseOp'] = false;
                    console.error('Error running command:', error);
                });
            },
            getAsignJobsIds() {
                if (this.docId) {
                    this.jobsList.loading = true;
                    jobs.getJobs({documentId:this.docId, limit: this.jobsList.limit, offset:this.jobsList.offset}).then(response => {
                        this.jobsList.results = response.data.results;
                        this.jobsList.count = response.data.count;
                        this.jobsList.loading = false;
                    }).catch(error => {
                        this.jobsList.loading = false;
                        this.jobsList.results = [];
                        this.jobsList.count = 0;
                    });
                }
            },
            setPageAsignJobs(page) {
                this.jobsList.offset = (page - 1) * this.jobsList.limit;
                getAsignJobsIds();
            },
            getItemPerPageAsignJobs(limit) {
                this.jobsList.limit = limit
                this.jobsList.offset = 0;
                getAsignJobsIds();
            },
            clickRowAsignJobs(row) {
                this.ajId = row.id;
                this.go_admin('/admin/jobs/asyncjob/' + this.ajId + '/change/');
            },
            get_remote_ops_settings() {
                client.get('get_remote_ops_settings/').then(response => {
                    this.remote_ops_settings = response.data;
                }).catch(err => {
                    console.debug(err);
                });
            },
            update_remote_ops_settings(key, value) {
                let payload = this.remote_ops_settings;
                payload[key] = value;
                client.put('update_remote_ops_settings/', { 'payload': payload }).then(() => {
                    this.get_remote_ops_settings();
                });
            },
            async copyExeLink() {
                this.loading_copy = true;
                await this.setExeLink();
                navigator.clipboard.writeText(this.exe_link);
                this.loading_copy = false;
            },

            async copyToken() {
                this.loading_copy = true;
                const repo = createApiTokenRepository();
                let {token}  =  await getToken(repo)
                copyToken(repo, token)
                this.loading_copy = false;
            },
            showCreateCustomCharge() {
                this.actionModal = 'createCustomCharge';
                this.customCharge.form = {
                        lines: [{ concept: '', quantity: 1, amount: null}]
                    },
                this.customCharge.showDialog = true;
            },
            clearCache() {
                new ClearUserCaches(sync_command_dispatcher).run(this.userData.user).then((response) => {
                        console.log(response)
                    })
                    .catch(error => {
                        console.error('Error clearing caches user:', error);
                        });
            },
            async createRunCommand(send_params) {
                let cmd = new RunCommandCreationCommand(sync_command_dispatcher, this)
                if (send_params) {
                    await cmd.run(this.args_run_command)
                } else {
                    await cmd.run()
                }
            },
            async updateValueWindows64() {
                await new ChangeWindowsArchitectureSettingsCommand(sync_command_dispatcher,query_dispatcher,this).run(this.def_set_windows_64)
            },
            async getOSArchitectureFromSettings() {
                await new GetOSArchitectureQuery(query_dispatcher, this).run(this.def_set_windows_64)
            },
            installService() {
                if (this.isElectron) {
                    this.is_to_pending['InstallingService'] = true;
                    window.electronAPI.installService().then(() => {
                        this.is_to_pending['InstallingService'] = false;
                        console.log("Installation complete")
                    });
                }
            },
            setSnackbar(color, text) {
                if (text != '') {
                    this.snackbar.text = text;
                    this.snackbar.isVisible = true;
                    this.snackbar.color = color;
                }
                else {
                    this.snackbar.text = '';
                    this.snackbar.isVisible = false;
                }
            },
            createAutoflowOP(workflow){
              client.put('create_operation_no_staff/', {
                'params': {
                  'name': 'Autoflow',
                  'channel': 'rest',
                  'args': {
                    'workflow': workflow,
                    ...(workflow === 'take_video' ? { 'duration': 50 } : {})
                  },
                  'companydb': this.currentCompany.id
                },
              }).then(() => {}).catch((error) => {
                console.error("Error creating autoflow import operation", error);
              });
            },
            hasThreadId(msg) {
                return msg && /- Thread ID: \d+/.test(msg);
            },
            extractThreadId(msg) {
                const match = msg.match(/- Thread ID: (\d+)/);
                return match ? match[1] : null;
            },
            async create_kill_process_op(threadId) {
                const killThreadProcess = new KillThreadProcess(
                    sync_command_dispatcher,
                    this.killThreadScreenData,
                    this
                );
                await killThreadProcess.run(threadId);
            },
            async create_test_kill_process_op(threadId) {
                const killThreadProcess = new KillThreadProcess(
                    sync_command_dispatcher,
                    this.killThreadScreenData,
                    this
                );
                await killThreadProcess.run(threadId, { kill_subprocess: false });
            },
        },
        async mounted() {
            if (this.username) {
                this.setLoginas(this.username).then(()=>{
                    this.$router.push('/debug');
                });
            } else {
                this.get_users();
            }
            await this.getOSArchitectureFromSettings()

            this.isElectron = navigator.userAgent == 'InmaticApp';
        },
    }
</script>

<style lang="scss" scoped>
    .buttom-border {
        border-bottom-style:solid;
        border-color: var(--v-primary-base);
        border-width: thin;
    }
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        /* border-bottom-style:solid; */
        border-color: var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;  
        border-color: var(--v-primary-base);
        border-width: thin;
    }
    .table-name {
        border-left-style:solid;
        border-color: var(--v-primary-base);
        border-width: thin;
    }
    .final-row {
        border-right-style:solid;
    }

    .cdb__go-detail {
        cursor: pointer;
        color: var(--v-primary-base);
        text-decoration: underline;
    }
</style>
